// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"710352b1","453":"090d6d4b","455":"3800e70a","977":"aee0f4e6"}[chunkId] + ".chunk.js";
};